module.exports = __webpack_public_path__ + "static/media/marian-ford.3eccf8d6.png";